import { createAction, props } from '@ngrx/store';
import { PermPostOfferInterviewSubmittal } from '../models/perm-post-offer-interview.model';
import { SubmittalStatus } from 'src/app/shared/models/submittal-status.model';
import { PermPostOfferInterviewActionPayload } from '../models/perm-post-offer-interview-action-payload.model';

export const openInterviewModal = createAction(
    '[Submittal Statuses Dropdown Component] Open Perm Interview Modal',
    props<{ payload: PermPostOfferInterviewActionPayload }>()
);

export const closeInterviewModal = createAction(
    '[Submittal Statuses Dropdown Component] Close Perm Interview Modal'
);

export const setPermanentJobSubmittalToInterview = createAction(
    '[Perm Interview Modal Component] Update Job Submittal Status to Interview',
    props<{ isLegacyWorkflow: boolean; permPostOfferInterviewSubmittal: PermPostOfferInterviewSubmittal }>()
);

export const setPermanentJobSubmittalToInterviewSuccess = createAction(
    '[Post Offer API] Update Job Submittal Status to Interview Success'
);

export const setPermanentJobSubmittalToInterviewFailure = createAction(
    '[Post Offer API] Update Job Submittal Status to Interview Failure',
    props<{ error: unknown }>()
);

export const getPermSubmittalStatuses = createAction('[Am Submittals Component] Get Job Submittal Statuses');

export const getPermSubmittalStatusesSuccess = createAction(
    '[Post Offer API] Get Job Submittal Statuses Success',
    props<{ statuses: SubmittalStatus[] }>()
);

export const getPermSubmittalStatusesFailure = createAction(
    '[Post Offer API] Get Job Submittal Statuses Failure',
    props<{ error: unknown }>()
);

export const clearError = createAction('[Perm Interview Modal Component] Clear Store Error');
